module.exports = __webpack_public_path__ + "img/1F1E6-1F1FC.b7f3f479.svg";